import { Flex, INNER_MAX_WIDTH, Text } from "@capioweb/ui-components"
import React from "react"
import { BooleanProperty } from "../../@types/EpiFoundationSpa/Property"
import { clamp } from "../../utils/clamp"
import { BlockCommonLayout } from "../../utils/layout"
import { BmiBar } from "./BmiBar"
import { BmiInput } from "./BmiInput"
import { calculateBmi } from "./utils/calculateBmi"

interface BmiCardProps {
	length?: number
	weight?: number
	description: string
	header: string
	marginBottom?: BooleanProperty
	onBmiCalculated: (length: number, weight: number) => void
	showResultBar?: boolean
	inputTexts: {
		length: string
		weight: string
		button: string
	}
	barTexts?: {
		bmi: string
		normalWeight: string
		obese: string
		overWeight: string
		underWeight: string
	}
	resultTexts?: {
		yourBmi: string
	}
}

export const BmiCard: React.FC<BmiCardProps> = ({
	barTexts,
	description,
	header,
	inputTexts,
	length,
	onBmiCalculated,
	resultTexts,
	showResultBar,
	weight,
	marginBottom,
}) => {
	const bmi = calculateBmi(weight, length)
	return (
		<Flex
			backgroundColor={"blue11"}
			flexDirection={"column"}
			alignItems={"center"}
			py={6.5}
			width={"100%"}
			mb={marginBottom?.value ? 3 : 0}
		>
			<BlockCommonLayout>
				<Flex
					alignItems="center"
					flexDirection="column"
					w={1}
					maxw={INNER_MAX_WIDTH}
					m="0 auto"
				>
					<Flex flexDirection={"column"} width={"100%"} px={{ _: 3, l: 0 }}>
						<Text variant={"headline-2"} textAlign={"center"}>
							{header}
						</Text>
						<Flex alignSelf={"center"} justifyContent={"center"}>
							<Text>{description}</Text>
						</Flex>
						<BmiInput
							length={length}
							onBmiCalculated={onBmiCalculated}
							weight={weight}
							texts={{
								length: inputTexts.length,
								weight: inputTexts.weight,
								button: inputTexts.button,
							}}
						/>
					</Flex>
					{showResultBar && resultTexts && (
						<Flex
							alignItems={"center"}
							flexDirection={"column"}
							width={"100%"}
							px={{ _: 0, l: 19.5 }}
							overflow={"hidden"}
						>
							<Flex
								width={{ _: "200%", l: "100%" }}
								ml={{ _: `${clamp(10 * (25 - bmi) * 2, -100, 100)}%`, l: 0 }}
							>
								<BmiBar bmi={bmi} barTexts={barTexts} />
							</Flex>
						</Flex>
					)}
				</Flex>
			</BlockCommonLayout>
		</Flex>
	)
}
